import { CookieConsent } from "../stores/cookie-store";

// Abstract base class for cookie services
abstract class CookieService {
  abstract initialize(consent: boolean): void;
  abstract cleanup(): void;
}

// Google Analytics Service
export class AnalyticsService extends CookieService {
  initialize(consent: boolean): void {
    if (typeof window === "undefined") return;

    window.gtag?.("consent", "update", {
      analytics_storage: consent ? "granted" : "denied",
    });
  }

  cleanup(): void {
    if (typeof window === "undefined") return;

    window.gtag?.("consent", "update", {
      analytics_storage: "denied",
    });
  }
}

// Google Ads Service
export class AdsService extends CookieService {
  initialize(consent: boolean): void {
    if (typeof window === "undefined") return;

    window.gtag?.("consent", "update", {
      ad_storage: consent ? "granted" : "denied",
    });
  }

  cleanup(): void {
    if (typeof window === "undefined") return;

    window.gtag?.("consent", "update", {
      ad_storage: "denied",
    });
  }
}

// Ad User Data Service
export class AdUserDataService extends CookieService {
  initialize(consent: boolean): void {
    if (typeof window === "undefined") return;

    window.gtag?.("consent", "update", {
      ad_user_data: consent ? "granted" : "denied",
    });
  }

  cleanup(): void {
    if (typeof window === "undefined") return;

    window.gtag?.("consent", "update", {
      ad_user_data: "denied",
    });
  }
}

// Ad Personalization Service
export class AdPersonalizationService extends CookieService {
  initialize(consent: boolean): void {
    if (typeof window === "undefined") return;

    window.gtag?.("consent", "update", {
      ad_personalization: consent ? "granted" : "denied",
    });
  }

  cleanup(): void {
    if (typeof window === "undefined") return;

    window.gtag?.("consent", "update", {
      ad_personalization: "denied",
    });
  }
}

// Turnstile Service
export class TurnstileService extends CookieService {
  initialize(): void {
    // Turnstile initialization logic if needed
    // Currently, the consent is checked directly in the Contact component
  }

  cleanup(): void {
    // Cleanup logic for Turnstile if needed
  }
}

// Preferences Service
export class PreferencesService extends CookieService {
  initialize(): void {
    // Initialize any preference-related functionality
  }

  cleanup(): void {
    // Cleanup any preference-related functionality
  }
}

// Cookie Service Manager
export class CookieServiceManager {
  private services: Map<keyof CookieConsent, CookieService>;

  constructor() {
    this.services = new Map([
      ["analytics", new AnalyticsService()],
      ["turnstile", new TurnstileService()],
      ["preferences", new PreferencesService()],
      ["ads", new AdsService()],
      ["ad_user_data", new AdUserDataService()],
      ["ad_personalization", new AdPersonalizationService()],
    ]);
  }

  updateConsent(consent: CookieConsent): void {
    for (const [key, service] of this.services) {
      service.initialize(consent[key]);
    }
  }

  cleanup(): void {
    for (const service of this.services.values()) {
      service.cleanup();
    }
  }
}

// Global instance
export const cookieServiceManager = new CookieServiceManager();

// Type declaration for window.gtag
declare global {
  interface Window {
    gtag?: (command: string, ...args: unknown[]) => void;
  }
}
